module.exports = __webpack_public_path__ + "static/media/login.3c34f3ec.jpg";